export * from './lib/components/finalized-orcamento/finalized-orcamento.component';
export * from './lib/portal-do-vendedor-ui-finalized-orcamento.module';
